import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery';
import DropDownCellCorrelativaFDO from './myDropDownCellCorrelativaFDO';
import NumericCellDinamic from './NumericTextDinamic';

class DropDownCellRegistoFDO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: '',
      optionsCapacidades: [],
      filteredOptions: [],
    };
  }

  handleFilterChange = (event) => {
    const filter = event.filter.value.toLowerCase();
    const filteredOptions = this.state.optionsCapacidades.filter(option =>
      option.text.toLowerCase().includes(filter)
    );
    this.setState({ filter, filteredOptions });
  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });

    DropDownCellCorrelativaFDO.ChangeValueById(e.target.value);
    NumericCellDinamic.ChangeValueById("Registo" , e.target.value);
  }

  componentDidMount = () => {
    this.loadData();
  }
  


  loadData = async () => {
    if ($('#instal_vinica_auto').val() !== '' && $('#instal_vinica_auto').val() !== null) {
      const data = { "IDInstalacaoVinica": $('#instal_vinica_auto').val().split('!')[0] , "idEntidade" : $('#instal_vinica_auto').val().split('!')[1]};
      const ProdutoList = await services.apiCall.requestApi(
        "/Fiscalizacao/GetProdutosByInstAndEnt",
        data,
        "get"
      );

      if (ProdutoList) {
        const optionsCapacidades = ProdutoList.map((Produto) => ({
          text: Produto.numeroRegisto,
          value: Produto.idRegistoProduto
        }));

        this.setState({ optionsCapacidades, filteredOptions: optionsCapacidades });
      }
    }
  }

  render() {
    const { dataItem } = this.props;
    const field = this.props.field || '';
    const dataValue = dataItem[field] || '';

    return (
      <td>
        {dataItem.inEdit ? (
          <DropDownList
            popupSettings={{
              width: 'max-content',
            }}
            filterable={true}
            filter={this.state.filter}
            onFilterChange={this.handleFilterChange}
            onChange={this.handleChange}
            value={this.state.optionsCapacidades.find(c => c.value === (dataValue.value || dataValue))}
            data={this.state.filteredOptions}
            textField="text"
            id='id-DropDownCellCapacidades'
          />
        ) : dataValue && dataValue.text ? dataValue.text.toString() : ''}
      </td>
    );
  }
}

export default DropDownCellRegistoFDO;
